import { render } from "./FanfouIcon.vue?vue&type=template&id=5badec61&scoped=true"
import script from "./FanfouIcon.vue?vue&type=script&lang=js"
export * from "./FanfouIcon.vue?vue&type=script&lang=js"

import "./FanfouIcon.vue?vue&type=style&index=0&id=5badec61&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/webtool/www-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5badec61"]])

export default __exports__